import React from 'react';
import { t } from 'ttag';
import DependencyItem from './dependencyItemComponent';
import getFlattenedParts from '../../services/helper/getFlattenedParts';

function DependencyList({ item, parts, closeModal, configuration }) {
    const dependencyActive = (part) => {
        let isActive = false;
        Object.values(configuration).forEach((value) => {
            if (Array.isArray(value)) {
                if (isActive === false) {
                    isActive = (value.find(element => element.uid === part.uid) !== undefined);
                }
            } else if (value !== null) {
                if (isActive === false) {
                    isActive = value.uid === part.uid;
                }
            }
        });
        return isActive;
    };

    const dependencyDescription = () => {
        const dependencyDescriptionList = {};
        const flattenedParts = getFlattenedParts(parts);

        if (item.depends_on.length > 0) {
            const dependsOnParts =
                flattenedParts.filter((part) => item.depends_on.indexOf(part.uid) !== -1);

            const dependsOnPartsInactive = dependsOnParts.filter((part) => !dependencyActive(part));
            dependencyDescriptionList.dependsOn = dependsOnPartsInactive;
        }

        if (item.exclude.length > 0) {
            const excludeParts =
                flattenedParts.filter((part) => item.exclude.indexOf(part.uid) !== -1);

            const excludePartsActive = excludeParts.filter((part) => dependencyActive(part));
            // Füge excludeParts zu dependencyDescriptionList.exclude hinzu,
            // nur wenn excludePartsActive Einträge enthält
            if (excludeParts.length > 0 && excludePartsActive.length > 0) {
                dependencyDescriptionList.exclude = excludeParts;
            }
        }

        /**
        if (item.exclusive_or.length > 0) {
            const exclusiveOrParts =
            flattenedParts.filter((part) => item.exclusive_or.indexOf(part.uid) !== -1);

            dependencyDescriptionList.exclusiveOr = exclusiveOrParts;
        }
         */

        // Initialize the exclusiveOrParts array
        let exclusiveOrParts = [];
        // Check and process the first exclusive_or array
        if (item.exclusive_or.length > 0) {
            exclusiveOrParts = exclusiveOrParts.concat(
                flattenedParts.filter((part) => item.exclusive_or.indexOf(part.uid) !== -1)
            );
        }

        // Check and process the second exclusive_or2 array
        if (item.exclusive_or2.length > 0) {
            exclusiveOrParts = exclusiveOrParts.concat(
                flattenedParts.filter((part) => item.exclusive_or2.indexOf(part.uid) !== -1)
            );
        }

        // Remove duplicates if any (assuming 'uid' is unique)
        const uniqueExclusiveOrParts = Array.from(new Set(exclusiveOrParts.map(part => part.uid)))
            .map(uid => exclusiveOrParts.find(part => part.uid === uid));

        // Update dependencyDescriptionList
        dependencyDescriptionList.exclusiveOr = uniqueExclusiveOrParts;

        return dependencyDescriptionList;
    };

    const listItemsDependsOn = dependencyDescription().dependsOn &&
    dependencyDescription().dependsOn.length > 0 ?
        dependencyDescription().dependsOn.map((element) => (
            <DependencyItem
                part={element}
                closeModal={closeModal}
            />
        )
    ) : null;

    const listItemsExclude = dependencyDescription().exclude &&
    dependencyDescription().exclude.length > 0 ?
        dependencyDescription().exclude.map((element) => (
            <DependencyItem
                part={element}
                closeModal={closeModal}
            />
        )
    ) : null;

    const listItemsExclusiveOr = dependencyDescription().exclusiveOr &&
    dependencyDescription().exclusiveOr.length > 0 ?
        dependencyDescription().exclusiveOr.map((element) => (
            <DependencyItem
                part={element}
                closeModal={closeModal}
            />
        )
    ) : null;

    return (
        <div>
            {
                listItemsDependsOn ?
                    <div>
                        {t`Wählbar nur in Verbindung mit`}
                        <ul>{listItemsDependsOn}</ul>
                    </div> : null
            }
            {
                listItemsExclude ?
                    <div>
                        {t`Nicht wählbar in Verbindung mit`}
                        <ul>{listItemsExclude}</ul>
                    </div> : null
            }
            {
                listItemsExclusiveOr ?
                    <div>
                        {t`Wählbar nur in Verbindung mit`}
                        <ul>{listItemsExclusiveOr}</ul>
                    </div> : null
            }
        </div>
    );

}

export default DependencyList;
